import { createEffect, createEvent, createStore } from 'effector';
import { createFilterBag } from '@shared/factories';
import { createForm } from '@unicorn/effector-form';
import type { FiltersForm, StoredFilters } from './types';
import { validationSchema } from './validation';

export const filtersKey = 'tickets-filter';

export const defaultFilters: FiltersForm = {
  periodOfCreation: [null, null],
  statuses: [],
  isTehzor: false,
  isSupportActive: false,
  priorities: [],
  classes: [],
  types: [],
  payment: null,
  invoiceStatus: null,
  objects: [],
  houses: [],
  apartments: [],
  property: [],
  initiators: [],
  stuffWriteOffNeeded: null,
  expired: null,
  assignees: [],
  rates: [],
  isUnreadMessage: false,
  hasRelated: false,
};

export const filtersForm = createForm<FiltersForm>({
  initialValues: defaultFilters,
  validationSchema,
});

export const {
  changedFilterVisibility,
  $isFilterOpen,
  $isFiltersApply,
  $isDefaultFilterValues,
} = createFilterBag(defaultFilters, filtersForm, {
  resetFormOnSignout: false,
  submitFormOnReset: false,
});

export const setFilters = createEvent<StoredFilters>();
export const applyFilters = createEvent<FiltersForm>();
export const filtersReadyToSubmit = createEvent<FiltersForm>();
export const $pendingFilters = createStore<FiltersForm | null>(null);

export const fxSetLocaleStorage = createEffect<
  { key: string; data: string },
  void,
  Error
>().use(({ key, data }) => localStorage.setItem(key, data));
